// authProvider.js
import { EventType, PublicClientApplication } from '@azure/msal-browser';
import { AuthConfigs } from './authConfigs';
import { createAuthorizationChecker } from './authorizationChecker';
const origin = window.location.origin;
const redirectUri = `${origin}/auth.html`;
// Msal Configurations
export const msalConfig = {
    auth: {
        clientId: AuthConfigs.CLIENT_ID,
        authority: AuthConfigs.AUTHORITY_URL,
        redirectUri,
        postLogoutRedirectUri: origin,
        redirectStartPage: origin,
        forceRefresh: false
    },
    cache: {
        cacheLocation: 'localStorage',
        storeAuthStateInCookie: true
    },
    system: {
        popupBridgeTimeout: 9000,
        iframeBridgeTimeout: 9000,
        redirectNavigationTimeout: 9000,
        loadFrameTimeout: 9000 // Applies to both silent and popup calls - In milliseconds
    }
};
export const msalInstance = new PublicClientApplication(msalConfig);
export const msalInitPromise = msalInstance.initialize().then(() => {
    const accounts = msalInstance.getAllAccounts();
    if (accounts.length > 0) {
        msalInstance.setActiveAccount(accounts[0]);
    }
    msalInstance.addEventCallback((event) => {
        if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
            const payload = event.payload;
            const account = payload.account;
            msalInstance.setActiveAccount(account);
        }
    });
    msalInstance
        .handleRedirectPromise()
        .then((tokenResponse) => {
        if (tokenResponse)
            window.location.replace('/');
    })
        .catch((error) => {
        console.error(error);
        // PKCE code_verifier mismatch (AADSTS501481): the auth state stored before the redirect
        // is stale or corrupted. Clear the entire MSAL cache and redirect to origin so a fresh
        // authorization request (with a new code_challenge/verifier pair) is initiated.
        const isPkceError = error?.errorCode === 'invalid_grant' ||
            error?.message?.includes('AADSTS501481') ||
            error?.message?.includes('Code_Verifier');
        if (isPkceError) {
            msalInstance.clearCache().finally(() => {
                window.location.replace(origin);
            });
        }
    });
});
export const authorizationChecker = createAuthorizationChecker();
